(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var media = window.matchMedia('(min-width: 990px)');

    function syncFooterMenus() {
      document.querySelectorAll('.footer-menu').forEach(function (menu) {
        if (media.matches) {
          menu.setAttribute('open', '');
        } else {
          menu.removeAttribute('open');
        }
      });
    }

    if (media.addEventListener) {
      media.addEventListener('change', syncFooterMenus);
    } else if (media.addListener) {
      media.addListener(syncFooterMenus);
    }

    syncFooterMenus();

    var menus = document.querySelector('.footer-menus');
    if (menus) {
      menus.addEventListener('click', function (event) {
        var link = event.target.closest('[data-footer-accessibility-tool]');
        if (!link) return;

        var tool = document.querySelector('[aria-label="Explore your accessibility options"]');
        if (!tool) return;

        event.preventDefault();
        tool.click();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
